export class DateFormatter {
  tools_MonthArray: any = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ];

  GetStringDate(date: Date) {
    var result = "";
    var theDay = date.getDate();
    var theMonth = this.tools_MonthArray[date.getMonth()];
    var theYear = date.getFullYear();
    result = theDay + " " + theMonth + " " + theYear;
    return result;
  }

  GetDateFromJSON(jsonDate: string) {
    var re = /-?\d+/;
    var m = re.exec(jsonDate);
    var d = new Date(parseInt(m[0]));
    return d;
  }

  GetStringDateFromJSON(jsonDate: string) {
    if (jsonDate == null) {
      return "";
    }
    var re = /-?\d+/;
    var m = re.exec(jsonDate);
    var d = new Date(parseInt(m[0]));
    return this.GetStringDate(d);
  }

  GetStandardDateFromJson(jsonDate: string): Date {
    if (jsonDate == null) {
      return null;
    }
    var re = /-?\d+/;
    var m = re.exec(jsonDate);
    var d = new Date(parseInt(m[0]));
    return d;
  }

  GetStandardDate(date: Date) {
    var result = "";
    var theDay = date.getDate();
    var theMonth = this.tools_MonthArray[date.getMonth()];
    var theYear = date.getFullYear();
    result = theDay + "/" + theMonth + "/" + theYear;
    return result;
  }

  datePrecisionFixAdd(value: any): any {
    if (value) {
      let standardizedDate = this.GetStandardDateFromJson(
        JSON.stringify(value)
      );
      standardizedDate.setTime(standardizedDate.getTime() + 2 * 60 * 60 * 1000);
      return standardizedDate.toISOString();
    } else {
      return "";
    }
  }

  setHourMinuteForTimePicker(hour: number, minute: number): string {
    let stringHour = hour.toString();
    if (stringHour.length === 1) {
      stringHour = "0" + stringHour;
    } else {
      stringHour = stringHour;
    }
    let stringMinute = minute.toString();
    if (stringMinute.length === 1) {
      stringMinute = "0" + stringMinute;
    } else {
      stringMinute = stringMinute;
    }
    return stringHour + ":" + stringMinute;
  }

  removeDays(date): Date {
    date = new Date(date);
    date.setDate(date.getDate() - 1);
    date.setMonth(date.getMonth());
    date.setFullYear(date.getFullYear());
    return date;
  }

  toDateOnly(date: Date): string {
    if (!date) {
      return null;
    }
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  /**
   * Parse a date-only string (YYYY-MM-DD) as local time instead of UTC
   * This prevents timezone shift issues when working with date-only values
   */
  fromDateOnly(dateString: string | Date): Date {
    if (!dateString) {
      return null;
    }

    // If already a Date object, return it
    if (dateString instanceof Date) {
      return dateString;
    }

    // Parse date-only string as local time
    const parts = dateString.split('-');
    if (parts.length === 3) {
      const year = parseInt(parts[0], 10);
      const month = parseInt(parts[1], 10) - 1; // Months are 0-indexed
      const day = parseInt(parts[2], 10);
      return new Date(year, month, day, 0, 0, 0, 0);
    }

    // Fallback to standard Date parsing
    return new Date(dateString);
  }
}
